function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/** Deep-merge child theme JSON onto a parent (child wins). Skips `extends`. */
export function deepMergeThemeData(
  base: Record<string, unknown>,
  override: Record<string, unknown>,
): Record<string, unknown> {
  const merged: Record<string, unknown> = { ...base }

  for (const [key, value] of Object.entries(override)) {
    if (key === 'extends') continue
    const existing = merged[key]
    if (isPlainObject(value) && isPlainObject(existing)) {
      merged[key] = deepMergeThemeData(existing, value)
    } else if (value !== undefined) {
      merged[key] = value
    }
  }

  return merged
}
